<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="客户名称" prop="custName">
            <el-input
              v-model="formData.custName"
              placeholder="请输入客户名称"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户简称" prop="custShortName">
            <el-input
              v-model="formData.custShortName"
              placeholder="请输入客户简称"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户代码">
            <el-input
              v-model="formData.custNo"
              placeholder="系统自动生成"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="有效状态">
            <el-select
              v-model="formData.custStatus"
              size="small"
              placeholder="请选择"
              style="width:100%"
              disabled
              clearable
              filterable
            >
              <el-option label="有效" value="Y"> </el-option>
              <el-option label="无效" value="N"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="客户类型">
            <dict-select
              clearable
              v-model="formData.customerType"
              placeholder="请选择客户类型"
              default
              filterable
              :body="customerTypeDictParams"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户行业">
            <dict-select
              v-model="formData.custIndustry"
              placeholder="请选择客户行业"
              default
              clearable
              filterable
              :body="custIndustryDictParams"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经营地址">
            <el-input
              v-model="formData.businessAddress"
              placeholder="请输入经营地址"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注信息" prop="custRemarks">
            <el-input
              v-model="formData.custRemarks"
              type="textarea"
              placeholder="请输入备注信息"
              maxlength="500"
              show-word-limit
              :rows="3"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="side-frame-success group-title">工商信息</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="营业执照号" prop="businessLicense">
            <el-input
              v-model="formData.businessLicense"
              placeholder="请输入营业执照号"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="税号" prop="taxNumber">
            <el-input
              v-model="formData.taxNumber"
              placeholder="请输入税号"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="成立日期">
            <el-date-picker
              type="date"
              v-model="formData.establishmentDate"
              placeholder="选择成立日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="注册资金" prop="registeredCapital">
            <el-input
              v-model="formData.registeredCapital"
              placeholder="请输入注册资金"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="法定代表人" prop="legalRepresentative">
            <el-input
              v-model="formData.legalRepresentative"
              placeholder="请输入法定代表人"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="固定电话">
            <el-input
              v-model="formData.phoneNo"
              placeholder="请输入固定电话"
              maxlength="40"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址" prop="registeredAddress">
            <el-input
              v-model="formData.registeredAddress"
              placeholder="请输入注册地址"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="side-frame-success group-title">财务信息</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="开户银行">
            <el-input
              v-model="formData.depositBank"
              placeholder="请输入开户银行"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票抬头">
            <el-input
              v-model="formData.invoiceTitle"
              placeholder="请输入发票抬头"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票地址">
            <el-input
              v-model="formData.invoiceAddress"
              placeholder="请输入开票地址"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input
              v-model="formData.bankAccount"
              maxlength="50"
              placeholder="请输入银行账号"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="财务代码">
            <el-input
              v-model="formData.financialCode"
              placeholder="请输入财务代码"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="信用天数">
            <el-input-number
              v-model.number="formData.creditDays"
              placeholder="请输入信用天数"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="信用额度">
            <el-input-number
              v-model.number="formData.creditLimit"
              placeholder="请输入信用额度"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              clearable
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <div class="side-frame-success group-title">结算设置</div>
        <el-col :span="6">
          <el-form-item label="是否自动生成账单" prop="isAutoSettlement">
            <el-select
              v-model="formData.isAutoSettlement"
              size="small"
              clearable
              placeholder="请选择"
              style="width:100%"
              filterable
            >
              <el-option label="自动生成" value="Y"> </el-option>
              <el-option label="手动生成" value="N"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="账单生成日" prop="custSettlementDate">
            <el-input
              v-model.number="formData.custSettlementDate"
              placeholder="请输入账单生成日"
              :disabled="isDisableCustSettlementDate"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算条件">
            <dict-select
              v-model="formData.custSettlementCondition"
              placeholder="请选择结算条件"
              default
              clearable
              filterable
              :body="custSettlementConditionDictParams"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算客户">
            <dict-select
              v-model="formData.parentCustNo"
              url="/master/customer/info/select/no"
              placeholder="请选择结算客户"
              :disabled="isDisableParentCust"
              filterable
              clearable
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="回单要求" prop="isNeedPod">
            <el-select
              v-model="formData.isNeedPod"
              size="small"
              placeholder="请选择"
              style="width:100%"
              clearable
              filterable
            >
              <el-option label="无需回单" value="N"> </el-option>
              <el-option label="原件回单" value="Y"> </el-option>
              <el-option label="复印件回单" value="F"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="回单周期">
            <el-input-number
              v-model="formData.podCycle"
              placeholder="请输入回单周期"
              :disabled="isDisablePodCycle"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="默认电子围栏半径（米）">
            <el-input-number
              v-model.number="formData.electronicFence"
              placeholder="请输入电子围栏半径"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建订单检查" prop="isMustCustPoints">
            <el-select
              v-model="formData.isMustCustPoints"
              size="small"
              placeholder="请选择"
              clearable
              style="width:100%"
              filterable
            >
              <el-option label="必须在门点范围内创建订单" value="Y">
              </el-option>
              <el-option label="创建订单时不检查门点" value="N"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button v-if="!disabled" type="primary" size="small" @click="save()"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    isDisableParentCust: Boolean,
    params: { type: Object, default: () => {} },
  },
  components: {},
  data() {
    return {
      custSettlementConditionDictParams: { type: 'custSettlementCondition' },
      custIndustryDictParams: { type: 'custIndustry' },
      customerTypeDictParams: { type: 'customerType' },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7
        },
      },
      isDisableCustSettlementDate: false,
      isDisablePodCycle: false,
      backDialogVisible: false,
      formData: {
        custStatus: 'Y',
        isNeedPod: 'Y',
        isAutoSettlement: 'Y',
        isMustCustPoints: 'Y',
      },
      rules: {
        custName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { max: 66, message: '客户名称 字数最多为66位', trigger: 'blur' },
        ],
        custShortName: [
          { required: true, message: '请输入客户简称', trigger: 'blur' },
          { max: 16, message: '客户简称 字数最多为66位', trigger: 'blur' },
        ],
        bankAccount: [
          {
            // required: false,
            // message: '请输入正确的银行账号',
            // pattern: /^([1-9]{1})(\d{14,20})$/,
            validator:(rule, value, callback) => {
              let reg = /^(\d{1})(\d{14,20})$/
              let numReg = /^\d+$/
              if (reg.test(value)){
                callback()
              }else{
                if (value === null || value === undefined || value === ''){
                  callback()
                }else if (numReg.test(value) && value.length > 21){
                  this.$confirm('当前输入的账号大于21位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else if (numReg.test(value) && value.length < 15){
                  this.$confirm('当前输入的账号小于15位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else{
                  callback(new Error('请输入15~21位的银行账号'))
                }
              }
            },
            trigger: 'blur',
          },
        ],
        // phoneNo: [
        //   {
        //     required: false,
        //     message: '请输入正确的固定号码',
        //     pattern: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
        //     trigger: 'blur',
        //   },
        // ],
        custSettlementDate: [
          {
            required: false,
            message: '请输入正确的账单生成日',
            pattern: /^([1-9]|[1-2]\d|3[0-1])$/,
            trigger: 'blur',
          },
        ],
        isAutoSettlement: [
          {
            required: true,
            message: '请选择是否自动生成账单',
            trigger: 'blur',
          },
        ],
        isNeedPod: [
          { required: true, message: '请选择是否要求回单', trigger: 'blur' },
        ],
        isMustCustPoints: [
          {
            required: true,
            message: '请选择是否禁止使用未维护门点创建订单',
            trigger: 'blur',
          },
        ],
        custStatus: [
          { required: true, message: '请选择有效状态', trigger: 'blur' },
        ],
        businessLicense: [
          {
            pattern: /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/,
            message: '请输入正确的营业执照号',
            trigger: 'blur',
          },
        ],
        taxNumber: [
          {
            pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
            message: '请输入正确的税号',
            trigger: 'blur',
          },
        ],
        legalRepresentative: [
          { max: 16, message: '法定代表人 字数最多为16位', trigger: 'blur' },
        ],
        registeredCapital: [
          { max: 16, message: '注册资金 字数最多为16位', trigger: 'blur' },
        ],
        registeredAddress: [
          { max: 166, message: '注册地址 字数最多为166位', trigger: 'blur' },
        ],
        businessAddress: [
          { max: 166, message: '经营地址 字数最多为166位', trigger: 'blur' },
        ],
        invoiceAddress: [
          { max: 166, message: '开票地址 字数最多为166位', trigger: 'blur' },
        ],
        depositBank: [
          { max: 16, message: '开户银行 字数最多为16位', trigger: 'blur' },
        ],
        invoiceTitle: [
          { max: 66, message: '发票抬头 字数最多为66位', trigger: 'blur' },
        ],
        custRemarks: [
          { max: 666, message: '备注信息 字数最多为666位', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    /**
     * 侦听 是否自动生成账单(formData.isAutoSettlement)字段，判断是否禁用账单生成日控件
     */
    'formData.isAutoSettlement'() {
      if (this.formData.isAutoSettlement === 'N') {
        this.isDisableCustSettlementDate = true
        this.formData.custSettlementDate = null
      } else {
        this.isDisableCustSettlementDate = false
      }
    },
    /**
     * 侦听 是否回单(formData.isNeedPod)字段，判断是否禁用回单周期控件
     */
    'formData.isNeedPod'() {
      if (this.formData.isNeedPod === 'N') {
        this.isDisablePodCycle = true
        this.formData.podCycle = ''
      } else {
        this.isDisablePodCycle = false
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.params.custCode) return
      this.$api
        .masterCustomerDetailApi({
          custCode: this.params.custCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterCustomerSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$emit('codeChange', res.body)
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 5px;
}
.line {
  text-align: center;
}
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}
</style>
